import { type FC } from 'react';
import { type ZodError } from 'zod';
import { useFieldContext } from './contexts';
import { Field } from './Field';
import './TextareaField.scss';

interface Props {
  readonly characterLimit?: number | undefined;
  readonly isAutoFocus?: boolean;
  readonly isDisabled?: boolean;
  readonly isFixedSize?: boolean;
  readonly isLoading?: boolean;
  readonly isRequired?: boolean;
  readonly label: string;
  readonly placeholder: string;
  readonly rows?: number;
}

export const TextareaField: FC<Props> = ({
  isAutoFocus,
  characterLimit,
  isDisabled,
  isFixedSize,
  label,
  isLoading,
  placeholder,
  isRequired,
  rows,
}) => {
  const field = useFieldContext<string>();
  const length = field.state.value.length;
  return (
    <Field name={field.name} label={label}>
      <div className={`control ${isFixedSize ? 'has-fixed-size' : ''} ${isLoading ? 'is-loading' : ''}`}>
        <textarea
          autoFocus={isAutoFocus}
          className={`textarea ${field.state.meta.errors.length > 0 ? 'is-danger' : ''}`}
          placeholder={placeholder}
          required={isRequired ?? false}
          aria-required={isRequired ?? false}
          id={field.name}
          name={field.name}
          rows={rows}
          value={field.state.value}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          onBlur={field.handleBlur}
          onChange={(e) => {
            field.handleChange(e.target.value);
          }}
        />
      </div>
      {characterLimit ? (
        <p className={`help has-text-right is-size-7 ${length > characterLimit ? 'is-danger' : ''}`}>
          ({length}/{characterLimit.toFixed()})
        </p>
      ) : null}
      {field.state.meta.errors.map((error: ZodError, idx) => (
        <p key={idx} className={'help is-danger'}>
          {error.message}
        </p>
      ))}
    </Field>
  );
};
TextareaField.displayName = 'TextArea';
